import * as React from "react";
import * as _ from 'lodash';
import moment from "moment";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {Autocomplete} from "@mui/lab";
import {Box, Button, TextField, Grid, InputAdornment, Dialog, LinearProgress, Typography} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import SearchIcon from "@mui/icons-material/Search";
import {AgyleNamedIcon} from "../../../components/icons/agyle";
import {DictionariesAdminTable} from "./admin_dictionaries_table";
import {DictionariesAdminEditForm} from "./admin_dictionaries_edit";
import {AdminAPI} from "../admin_api";
import MessageBox from "../../../util/messageBox";
import {setSnackbar} from "../../../store/reducers/globals";
import {user} from "../../../store/reducers/user";
import {setLoading} from "../../../store/reducers/announcement";
import {ImportData} from "./import_data";
import AgyleDialog from '../../../components/modal/agyleDialog';
import {useEffect, useRef} from 'react';
import {DictionariesAdminMergeForm} from './admin_dictionaries_merge';
import {getStringValue} from './admin_dictionaries_helpers';
import {useDebounce} from 'use-debounce';
import clsx from "clsx";
import useActiveModules from '../../centralPage/hooks/useActiveModules';
import {useWebSocket} from '../../../context/WebSocketProvider';

const useStyles = makeStyles((theme) => ({
    additionalInfoBlock: {
        maxWidth: "calc(100% - 830px)",
        paddingRight: "10px"
    },
    selectDict: {
        display: "inline-flex",
        flexDirection: "column",
        margin: "8px 0px"
    },
    searchSection: {
    },
    btnSection: {
        textAlign: "right",
        paddingTop: "32px !important"
    },
    btnIcon: {
        marginRight: "16px",
        minWidth: "40px",
        padding: "5px 7px",
        width: "40px",
        height: "40px",
        border: "1px solid rgba(255, 255, 255, 0.25)",
        boxShadow: "1px 1px 3px -1px #bbbbbb",
        "&:hover": {
            borderWidth: "3px",
            borderColor: "#303f9f",
            boxShadow: "1px 1px 4px -1px #303f9f"
        },
        "& svg": {
            width: "34px",
            height: "34px",
            marginLeft: "2px"
        },
        "& svg.icon-manage": {
            width: "24px",
            height: "24px",
            marginLeft: "5px"
        }
    },
    btnWithIcon: {
        //marginLeft: "20px",
    },
    btnWithIconIcon: {
        marginRight: "3px"
    },
    icon: {},
    hiddenInput: {
        display: "none"
    },
    headerInfo:{
        marginTop: 0,
        paddingBottom: "10px"
    },
    baseInfo: {
        fontSize: "18px",
        paddingRight: "12px"
    },
    additionalInfo: {
        fontSize: "13px"
    },
    header:{
        marginTop: 0,
        fontWeight: 900,
        background: theme.palette.background.gridHeader,
        paddingBottom: "16px"
    },
    evenRow: {
        marginTop: 0,
        background: theme.palette.background.even,
    },
    oddRow: {
        marginTop: 0,
        background: theme.palette.background.odd,
    },
    even: {
        paddingTop: "3px !important",
        paddingBottom: "3px",
    },
    odd: {
        paddingTop: "3px !important",
        paddingBottom: "3px",
    }
}));
//here is managing object with combo selector and data manager

export function DictionariesAdmin(props) {
    const classes = useStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const {sendMessage, manageSubscription, message} = useWebSocket();

    const [dictList, setDictList] = React.useState([]);
    const [dictConfig, setDictConfig] = React.useState(null);
    const [masterRecordId, setMasterRecordId] = React.useState(null);
    const [additionalDicts, setAdditionalDicts] = React.useState({});
    const [additionalDictsAll, setAdditionalDictsAll] = React.useState({});
    const [addEdit, setAddEdit] = React.useState({open:false, record: null});
    const [mergeDialog, setMergeDialog] = React.useState({open:false, record: null});
    const [recordsReady, setRecordsReady] = React.useState(false);
    const [records, setRecords] = React.useState(null);
    const [currentRecordsPage, setCurrentRecordsPage] = React.useState(0);
    const [allPagesRead, setAllPagesRead] = React.useState(false);
    const [openConfirmDeleted, setOpenConfirmDeleted] = React.useState(false);
    const [rowAffectedAction, setRowAffectedAction] = React.useState(null);
    const [searchVal, setSearchVal] = React.useState("");
    const [debouncedSearchValue] = useDebounce(searchVal, 1500);
    const [searchTimeoutHandler, setSearchTimeoutHandler] = React.useState(Number(null));
    const defaultPageSize = props.pageSize ? props.pageSize : 1000;
    const userObject = useSelector(user);
    const wsMessageChanel = "admin_dictionaries_viewing_table";
    const [runSocket, setRunSocket] = React.useState(true);
    const [webSocketChanel, setWebSocketChanel] = React.useState("dictionary_admin_table_changes");
    const [componentId, setComponentId] = React.useState(_.uniqueId("admin_dictionaries_"));
    const [duplicatesInDict, setDuplicates] = React.useState([]);
    const [showDuplicatesMessage, setShowDuplicatesMessage] = React.useState(false);
    const searchRef = useRef(null);
    const [specialDividedFieldMap, setSpecialDividedFieldMap] = React.useState({});
    const [filterFieldMap, setFilterFieldMap] = React.useState({});
    const [activeModules, isModulesLoading] = useActiveModules();

    useEffect(() => {
        manageSubscription([webSocketChanel], runSocket)
    }, [webSocketChanel, runSocket]);

    React.useEffect(()=>{
        let dicts = [];

        _.forEach(props.dictionariesEditors, dict => dicts.push({label: dict.display, conf: dict}))

        setDictList(dicts);
        setComponentId(_.uniqueId("admin_dictionaries_"));
        return () => {
            if(searchTimeoutHandler){
                clearTimeout(searchTimeoutHandler);
            }
            manageSubscription([wsMessageChanel], false);
        }
    },[props.dictionariesEditors]);

    React.useEffect(()=>{
        setSearchVal(null);
        searchRef.current.value = null;
        if(searchTimeoutHandler){
            clearTimeout(searchTimeoutHandler);
        }
        let dictsAbortSignals = [];
        if(dictConfig) {
            setAllPagesRead(false);
            setRecords(null);
            setCurrentRecordsPage(0);
            setRecordsReady(false);
            // let dependencyTablesCount = dictConfig.conf.dependencyTables ? dictConfig.conf.dependencyTables.filter(
            //     (dt)=> {
            //         if(!dt.hasOwnProperty("moduleAccess")) return true;
            //         const am = _.find(activeModules, {"id": dt["moduleAccess"]});
            //         return am && am.enabled ? am.enabled : false;
            //     }).length : 0;
            const dependencyTables = dictConfig.conf.dependencyTables ? dictConfig.conf.dependencyTables.filter(
                (dt)=> {
                    if(!dt.hasOwnProperty("moduleAccess")) return true;
                    const am = _.find(activeModules, {"id": dt["moduleAccess"]});
                    return am && am.enabled ? am.enabled : false;
                }) : [];
            if(dependencyTables.length > 0){
                let dictsPromises = [];
                let dividedFunctionDicts = {};
                let i = 0;
                dependencyTables.forEach((dtItem) => {
                    dictsAbortSignals[i] = new AbortController();
                    if(dtItem.table) {
                        let filter = {};
                        if(dtItem.hasOwnProperty("filter")) {
                            try {
                                //console.log("filter", dictConfig.conf.dependencyTables[i]["filter"]);
                                filter = JSON.parse(dtItem["filter"]);
                            }
                            catch(ex) {
                                console.error(ex);
                            }
                        }
                        dictsPromises.push(AdminAPI.getTableData(dtItem.table, dictsAbortSignals[i].signal, filter, null, null, null, dtItem.api));
                    }
                    if(dtItem.masterTable && dtItem.fieldAsTable) {
                        dictsPromises.push(AdminAPI.getFieldAsTableFromMasterTable(dtItem.masterTable, dtItem.fieldAsTable, dictsAbortSignals[i].signal, dtItem.api));
                    }
                    if(dtItem.hasOwnProperty("useDivided")){
                        if(!dtItem["useDivided"].hasOwnProperty("moduleAccess") ||
                            (dtItem["useDivided"].hasOwnProperty("moduleAccess") &&
                             _.find(activeModules, {"id": dtItem["useDivided"]["moduleAccess"], "enabled": true})
                            )) {
                            if (dtItem["useDivided"]["additionalFunction"]) {
                                if (!dividedFunctionDicts.hasOwnProperty(dtItem["useDivided"]["additionalFunction"])) {
                                    dividedFunctionDicts[dtItem["useDivided"]["additionalFunction"]] = [];
                                }
                                dividedFunctionDicts[dtItem["useDivided"]["additionalFunction"]].push({
                                    dictName: dtItem.name,
                                    baseFieldId: dtItem["useDivided"].baseFieldId,
                                    listName: dtItem["useDivided"].listName
                                })
                            }
                        }
                    }
                    if(dtItem.hasOwnProperty("filterFields")){
                        let filterFields = {};
                        Object.keys(dtItem.filterFields).forEach((nestedFilter) => {
                            filterFields[nestedFilter] = [];
                            dtItem.filterFields[nestedFilter].forEach((filterHelperItem) => {
                                if(typeof filterHelperItem == "string") {
                                    filterFields[nestedFilter].push(filterHelperItem);
                                }
                                if(!filterHelperItem.hasOwnProperty('moduleAccess') || (filterHelperItem.hasOwnProperty('moduleAccess') && _.findIndex(activeModules, (am) => (am.id == filterHelperItem.moduleAccess)) > -1 )) {
                                    if(filterHelperItem.hasOwnProperty("field")) {
                                        filterFields[nestedFilter].push(filterHelperItem.field);
                                    }
                                }
                            })
                        })
                        setFilterFieldMap(filterFields);
                    }
                    i++;
                })
                setSpecialDividedFieldMap(dividedFunctionDicts);
                //
                dictsAbortSignals[dependencyTables.length] = new AbortController();
                readTableRecordsPage(buildFetchFilter(searchVal),0,undefined, undefined, dictsAbortSignals[dependencyTables.length].signal, false).then((recordsPage)=> {
                    Promise.all(dictsPromises).then((dicts) => {
                        let dependencyDicts = {};
                        let dependencyDictsAll = {};
                        let tmpDuplicates = [];
                        for (let i = 0; i < dependencyTables.length; i++) {
                            const dictName = dictConfig.conf.dependencyTables[i].group ? dictConfig.conf.dependencyTables[i].group : dictConfig.conf.dependencyTables[i].name;
                            if(!dependencyDicts.hasOwnProperty(dictName)){
                                dependencyDicts[dictName] = [];
                            }
                            if(!dependencyDictsAll.hasOwnProperty(dictName)){
                                dependencyDictsAll[dictName] = [];
                            }
                            if(Array.isArray(dicts[i])){
                                dependencyDicts[dictName].push(..._.cloneDeep(dicts[i]));
                                dependencyDictsAll[dictName].push(..._.cloneDeep(dicts[i]));
                            } else {
                                if(dicts[i] && dicts[i].hasOwnProperty("data")){
                                    dependencyDicts[dictName].push(..._.cloneDeep(dicts[i]['data']));
                                    dependencyDictsAll[dictName].push(..._.cloneDeep(dicts[i]['data']));
                                }
                            }
                            let groupedItems = _.groupBy(dependencyDicts[dictConfig.conf.dependencyTables[i].name], (item) => {
                                let k = "";
                                if(dictConfig.conf.dependencyTables[i].dictDisplayField){
                                    k += item[dictConfig.conf.dependencyTables[i].dictDisplayField];
                                    if(dictConfig.conf.dependencyTables[i].dictDisplayFieldCode){
                                        k += "^^^" + getStringValue(item, dictConfig.conf.dependencyTables[i].dictDisplayFieldCode, "_");
                                    }
                                } else {
                                    if(item.hasOwnProperty("_id")) {
                                        if(typeof item["_id"] == "object"){
                                            k += item['_id']['$oid'];
                                        } else {
                                            k += item['_id'];
                                        }
                                    } else {
                                        k += "undefined";
                                    }
                                }
                                return k});
                            let duplicates = [];
                            let idsForDelete = [];
                            Object.keys(groupedItems).forEach((key) => {
                                if(groupedItems[key].length > 1) {
                                    duplicates.push({
                                        "dictName": dictConfig.conf.dependencyTables[i].name,
                                        "name": key.split('^^^')[0],
                                        "code": key.split('^^^').length > 1 ? key.split('^^^')[1].split("_").join(" ") : null,
                                        "records": _.cloneDeep(groupedItems[key])
                                    });
                                    groupedItems[key].forEach(item => {
                                        if(typeof item["_id"] == "object" && item["_id"].hasOwnProperty("$oid")){
                                            idsForDelete.push(item["_id"]["$oid"]);
                                        } else {
                                            idsForDelete.push(item["_id"]);
                                        }
                                    })
                                }
                            })
                            if(duplicates.length > 0){
                                tmpDuplicates = _.concat(tmpDuplicates, duplicates);
                                _.remove(dependencyDicts[dictConfig.conf.dependencyTables[i].name], (dictItem) => {
                                    if(typeof dictItem["_id"] == "object" && dictItem["_id"].hasOwnProperty("$oid")) {
                                        return idsForDelete.indexOf(dictItem["_id"]["$oid"]) > -1;
                                    }
                                    return idsForDelete.indexOf(dictItem["_id"]) > -1;
                                });
                            }
                        }
                        setDuplicates(tmpDuplicates);
                        if(tmpDuplicates.length > 0){
                            setShowDuplicatesMessage(true);
                        }
                        setAdditionalDicts(dependencyDicts);
                        setAdditionalDictsAll(dependencyDictsAll);
                        setRecordsReady(true);
                        setRecords([...recordsPage]);
                        setTimeout(()=>{
                            sendMessageNewUserViewingTable();
                        }, 1);
                    })
                })
            } else {
                dictsAbortSignals[0] = new AbortController();
                readTableRecordsPage(buildFetchFilter(searchVal),0,undefined, undefined, dictsAbortSignals[0].signal, false).then((recordsPage)=>{
                    setRecordsReady(true);
                    setRecords([...recordsPage]);
                    setTimeout(()=>{
                        sendMessageNewUserViewingTable();
                    }, 1);
                });
            }
            setRunSocket(false);
            setTimeout(()=>{
                setWebSocketChanel("dictionary_admin_table_changes_"+dictConfig?.conf?.name);
            }, 10);
        }
        return ()=> {
            setAdditionalDicts({});
            dictsAbortSignals.forEach((controller) => {
                controller.abort();
            });
            if(searchTimeoutHandler){
                clearTimeout(searchTimeoutHandler);
            }
        }
    }, [dictConfig, isModulesLoading]);

    const refreshPage = () => {
        if(searchVal && searchVal.length > 0) {
            if (searchTimeoutHandler) {
                clearTimeout(searchTimeoutHandler);
            }
            setSearchTimeoutHandler(setTimeout(() => {
                setRecords(null);
                setRecordsReady(false);
                setSearchTimeoutHandler(null);
                let filter = buildFetchFilter(searchVal);
                readTableRecordsPage(filter,0,undefined, undefined, (new AbortController()).signal, false).then((recordsPage)=>{
                    //console.log("setting recored after filter", recordsPage);
                    setRecords([...recordsPage]);
                    setRecordsReady(true);
                });
            }, 1000));
        } else {
            readTableRecordsPage(undefined,0,undefined, undefined, (new AbortController()).signal, false).then((recordsPage)=>{
                setRecordsReady(true);
                setRecords([...recordsPage]);
            });
        }
    }

    React.useEffect( () => {
        refreshPage();
    }, [debouncedSearchValue]);

    React.useEffect(()=> {
        if(message){
            try {
                const msg = message;
                if(msg && msg.id && msg.id != componentId) {
                    if (msg.data && msg.data.action) {
                        //console.log("new message arrived!!!", msg)
                        const id = msg.data.record[props.idField];
                        let index = -1;
                        switch (msg.data.action) {
                            case "modified":
                                //this manipulates records on master component
                                index = records.findIndex((record) => {
                                    return record[props.idField] == id;
                                });
                                if (index > -1) {
                                    let tmp = [...(records)];
                                    tmp[index] = msg.data.record
                                    setRecords(tmp);
                                }
                                break;
                            case "addNew":
                                setRecords([...records, msg.data.record]);
                                break;
                            case "delete":
                                index = records.findIndex((record) => {
                                    return record[props.idField] == id;
                                });
                                if (index > -1) {
                                    let tmp = [...(records)];
                                    tmp.splice(index,1);
                                    setRecords(tmp);
                                }
                                break;
                            case "closeEdit":
                                console.log("closeEdit - do nothing");
                                break;
                            default:
                                console.log("default - do nothing!");
                                break;
                        }
                    }
                }
            } catch (ex) {
                console.log(ex);
            }
        }
    }, [message])

    React.useEffect(()=> {
        setTimeout(()=>{
            setRunSocket(true);
        }, 1);
    }, [webSocketChanel]);

    const sendMessageNewUserViewingTable = () => {
        const data = {viewed: dictConfig.conf.name};
        sendMessage(data, wsMessageChanel);
    }

    const buildFetchFilter = (filter) => {
        let filterObj = {};
        if(filter && _.isObject(filter)) {
            return filter;
        } else
        if(filter) {
            let filters = [{"_id": {$regex:`.*${filter}.*`, $options: 'i'}}];
            if(dictConfig.conf.filterFields && dictConfig.conf.filterFields.length>0) {
                _.forEach(dictConfig.conf.filterFields, (field) => {
                    let f = {$regex: `.*${filter}.*`, $options: 'i'}
                    let o = {}
                    o[field] = f;
                    filters.push(o);
                });
            }
            filterObj = {$or:filters};
        }
        return filterObj;
    }

    /////read and more

    const readTableRecordsPage = (filter, page, pageSize=defaultPageSize, sort, signal, updateRecords=true) => {
        if(page == undefined){
            page = currentRecordsPage + 1;
            setCurrentRecordsPage(page);
        }
        return new Promise((resolve, reject) => {
            let api = dictConfig &&  dictConfig.conf && dictConfig.conf.apiConfigName ? dictConfig.conf.apiConfigName : undefined;
            let tableName = dictConfig &&  dictConfig.conf && dictConfig.conf.table ? dictConfig.conf.table : undefined;
            if(tableName) {
                AdminAPI.getTableData(dictConfig.conf.table, signal, filter, page, pageSize, sort, api).then(function (tableData) {
                    let retRecords;
                    if (tableData.length < pageSize || tableData.length == 0) {
                        setAllPagesRead(true);
                    } else {
                        setAllPagesRead(false);
                    }
                    if (records && page > 0) {
                        retRecords = [...records, ...tableData];
                    } else {
                        retRecords = [...tableData]
                    }
                    if (updateRecords) {
                        setRecords(retRecords);
                    }
                    setMasterRecordId(null);
                    resolve(retRecords);
                }, (error) => {
                    console.log(error);
                    reject(error);
                });
            } else {
                let masterTableName = dictConfig &&  dictConfig.conf && dictConfig.conf.masterDictionaryTable && dictConfig.conf.fieldAsTable ? dictConfig.conf.masterDictionaryTable : undefined;
                if(masterTableName){
                    AdminAPI.getFieldAsTableFromMasterTable(masterTableName, dictConfig.conf.fieldAsTable, signal, api).then(function (nestedTableData) {
                        setMasterRecordId(nestedTableData.id);
                        resolve(nestedTableData.data);
                        setAllPagesRead(true);
                        //setRecords(nestedTableData.data);
                    })
                } else {
                    if (updateRecords) {
                        //setRecords([]);
                        resolve([]);
                    }
                }
            }
        })
    }

    const handleCloseDialogEditForm = (event) => {
        setAddEdit({open: false, record: null});
    }

    const handleCloseDialogMerge = (event) => {
        setMergeDialog({open: false, record: null});
    }

    const sendMessageUserModifyTableRecord = (action, record) => {
        const data = {
            record: record,
            table: dictConfig.conf.name,
            action: action, ///openToEdit | editing | closeEdit (noChanges) | modified (withChanges) | addNew (withChanges) | delete (withRecordID)////
        }
        sendMessage(data, wsMessageChanel, componentId);
    }

    const mergeRecords = (idFrom,idTo) => {
        AdminAPI.mergeRecords(dictConfig?.conf?.mergeEndpoint,idFrom,idTo).then(result => {
            setMergeDialog(false);
            dispatch(setSnackbar({
                type: "info",
                message: t("Records merged")
            }));
            refreshPage();
        });
    }

    const saveAddEditForm = (editObj) => {
        setRecordsReady(false);
        if(masterRecordId) {
            const idField = dictConfig.conf.idFieldName;
            let data = _.cloneDeep(records);
            const itemIndex = _.findIndex(data, (currentItem) => {
                return JSON.stringify(currentItem[idField]) === JSON.stringify(editObj[idField]);
            });
            if(itemIndex > -1){
                data[itemIndex] = editObj;
            } else {
                data.push(editObj);
            }
            AdminAPI.updateMasterRecordFieldData(dictConfig.conf.masterDictionaryTable, dictConfig.conf.fieldAsTable, data).then(result => {
                if(typeof result == "object"){
                    setRecords(result[dictConfig.conf.fieldAsTable]);
                    setRowAffectedAction(null);
                    if(itemIndex > -1) {
                        sendMessageUserModifyTableRecord("addNew", result[dictConfig.conf.fieldAsTable]);
                    } else {
                        sendMessageUserModifyTableRecord("modified", result[dictConfig.conf.fieldAsTable]);
                    }
                } else {
                    dispatch(setSnackbar({
                        type: "error",
                        message: t("Error") + " [error on delete item on " + dictConfig.conf.masterDictionaryTable + " into field " + dictConfig.conf.fieldAsTable + "] ",
                    }));
                    setRowAffectedAction(null);
                }
                setAddEdit({open: false, record: null});
                setRecordsReady(true);
            })
        } else {
            let copyObj = _.cloneDeep(editObj);
            if (copyObj?._id === '' || copyObj?._id === null) delete copyObj?._id;
            AdminAPI.saveTableRecord(dictConfig.conf.table, copyObj, dictConfig.conf.api).then((savedRecord) => {
                //console.log("savedRecord", savedRecord);
                if (savedRecord) {
                    let recordsTmp = _.cloneDeep(records);
                    let itemIndex = _.findIndex(recordsTmp, (item) => {
                        return _.isEqual(item[dictConfig.conf.idFieldName], editObj[dictConfig.conf.idFieldName]);
                    })
                    if (itemIndex < 0) {
                        // new item
                        recordsTmp.push(savedRecord);
                        sendMessageUserModifyTableRecord("addNew", savedRecord);
                    } else {
                        recordsTmp[itemIndex] = savedRecord;
                        sendMessageUserModifyTableRecord("modified", savedRecord);
                    }
                    setRecords(recordsTmp);
                } else {
                    dispatch(setSnackbar({
                        type: "error",
                        message: t("Error") + ": " + t("Record not saved"),
                    }));
                }
                setAddEdit({open: false, record: null});
                setRecordsReady(true);
            }, (error) => {
                console.error('Error: ', error);
                dispatch(setSnackbar({
                    type: "error",
                    message: t("Error") + " [" + error + "] ",
                }));
                setAddEdit({open: false, record: null});
                setRecordsReady(true);
                sendMessageUserModifyTableRecord("modified", editObj);
            });
        }
    }

    const handleRowAction = (action, rowAffected, tableKey, extraData) => {
        if(!rowAffected.hasOwnProperty("technical") || (rowAffected.hasOwnProperty("technical") && !rowAffected.technical)) {
            setRowAffectedAction(rowAffected);
            switch (action) {
                case "delete":
                    setOpenConfirmDeleted(true);
                    break;
                case "edit":
                    setAddEdit({open: true, record: {...rowAffected}});
                    break;
                case "merge":
                    setMergeDialog({open: true, record: {...rowAffected}});
                    break;
                case "updateConsultants":
                    if(additionalDictsAll.hasOwnProperty("consultants")){
                        let additionalDictsAllCopy = _.cloneDeep(additionalDictsAll);
                        let additionalDictsCopy = _.cloneDeep(additionalDicts);
                        extraData.forEach(clsUpdatedData => {
                            const idx = _.findIndex(additionalDictsCopy.consultants, (clsToUpdate) => clsToUpdate._id === clsUpdatedData._id);
                            if(idx > -1){
                                additionalDictsCopy.consultants.splice(idx, 1, _.cloneDeep(clsUpdatedData));
                            }
                            const idxAll = _.findIndex(additionalDictsAllCopy.consultants, (clsToUpdate) => clsToUpdate._id === clsUpdatedData._id);
                            if(idxAll > -1){
                                additionalDictsAllCopy.consultants.splice(idxAll, 1, _.cloneDeep(clsUpdatedData));
                            }
                        });
                        setAdditionalDictsAll(additionalDictsAllCopy);
                    }
                    break;
            }
        } else {
            dispatch(setSnackbar({
                type: "error",
                message: t("Error") + " [" + t("Technical field can't be edited") + "] ",
            }));
        }
    }

    const handleDelete = () => {
        //real delete function, rebuild for  bookadmissions
        if(rowAffectedAction) {
            setOpenConfirmDeleted(false);
            if(masterRecordId) {
                const idField = dictConfig.conf.idFieldName;
                let data = _.cloneDeep(records)
                _.remove(data, (currentItem) => {
                    return JSON.stringify(currentItem[idField]) === JSON.stringify(rowAffectedAction[idField]);
                });
                AdminAPI.updateMasterRecordFieldData(dictConfig.conf.masterDictionaryTable, dictConfig.conf.fieldAsTable, data).then(result => {
                    if(typeof result == "object"){
                        setRecords(result[dictConfig.conf.fieldAsTable]);
                        setRowAffectedAction(null);
                        sendMessageUserModifyTableRecord("delete", rowAffectedAction[dictConfig.conf.idFieldName]);
                    } else {
                        dispatch(setSnackbar({
                            type: "error",
                            message: t("Error") + " [error on delete item on " + dictConfig.conf.masterDictionaryTable + " into field " + dictConfig.conf.fieldAsTable + "] ",
                        }));
                        setRowAffectedAction(null);
                    }
                })
            } else {
                AdminAPI.deleteTableRecord(dictConfig.conf.table, rowAffectedAction[dictConfig.conf.idFieldName]).then((res) => {
                    if (res) {
                        let recordsTmp = [...records];
                        let itemIndex = _.findIndex(recordsTmp, (item) => {
                            return item[dictConfig.conf.idFieldName] == rowAffectedAction[dictConfig.conf.idFieldName];
                        });
                        recordsTmp.splice(itemIndex, 1);
                        setRecords(recordsTmp);
                        setRowAffectedAction(null);
                        sendMessageUserModifyTableRecord("delete", rowAffectedAction[dictConfig.conf.idFieldName]);
                    }
                }, (error) => {

                    dispatch(setSnackbar({
                        type: "error",
                        message: t("Error") + " [" + error + "] ",
                    }));
                    setRowAffectedAction(null);
                })
            }
        }
    }

    const handleAddNewDictElement = (event) => {
        //create new property set according fields description
        let newRecord = {};
        dictConfig.conf.fields.forEach((field)=>{
            if(field.type == "text" && field.id != dictConfig.conf.idFieldName) {
                newRecord[field.id] = "";
            } else {
                newRecord[field.id] = null;
            }
        });
        setAddEdit({open:true, record: newRecord});
    }

    const handleDialogManageAccess = (event) => {

    }

    const saveDataToCSV = (tableData, header, headers) => {
        const replacer = (key, value) => (!value ? '' : value); // specify how you want to handle null values here
        const dateFields = getDateFields();
        if (dateFields.length > 0) {
            _.each(tableData, (r) => {
                recordDateToCSV(r, dateFields);
            });
        }
        const data = tableData.map((row) =>
            header.map(function (fieldName) {
                let val = row[fieldName];
                if (_.isObject(row[fieldName])) {
                    val = JSON.stringify(row[fieldName], replacer);
                }
                if (val && _.isString(val)) {
                    val = val.replace(/"/g, "'");
                    if (!val.startsWith('"')) {
                        val = `"${val}`;
                    }
                    if (!val.endsWith('"')) {
                        val = `${val}"`;
                    }
                }
                return val;
            }).join(','));
        saveCSVAndCloseLoading(headers + "\r\n" + data.join('\r\n'));
    }

    const exportCsv = (event) => {
        dispatch(setLoading(true));
        const header = [];
        const headerNames = [];
        dictConfig.conf.fields.forEach((field)=>{
            header.push(field.id);
            headerNames.push(field.display);
        });
        const headers = headerNames.join(',');
        let api = dictConfig &&  dictConfig.conf && dictConfig.conf.apiConfigName ? dictConfig.conf.apiConfigName : undefined;
        let tableName = dictConfig &&  dictConfig.conf && dictConfig.conf.table ? dictConfig.conf.table : undefined;
        if(tableName) {
            AdminAPI.getTableData(tableName, null, null, null, null, null, api).then((tableData) => {
                saveDataToCSV(tableData, header, headers);
            });
        } else {
            let masterTableName = dictConfig &&  dictConfig.conf && dictConfig.conf.masterDictionaryTable && dictConfig.conf.fieldAsTable ? dictConfig.conf.masterDictionaryTable : undefined;
            if(masterTableName){
                AdminAPI.getFieldAsTableFromMasterTable(masterTableName, dictConfig.conf.fieldAsTable, null, api).then(function (nestedTableData) {
                    saveDataToCSV(nestedTableData.data, header, headers);
                })
            }
        }
    }

    const recordDateToCSV = (row,dateFields) => {
        _.each(dateFields, (f) => {
            if(row[f] && _.isObject(row[f]) && row[f].$date) {
                let dateLong = Number(row[f].$date.$numberLong);
                row[f] = moment.utc(dateLong);
                if(row[f]) {
                    row[f] = row[f].format("YYYY-MM-DD HH:mm:ss")
                }
            }
        });
    }

    const getDateFields = () => {
        let dateFields = [];
        _.each(dictConfig.conf.fields, (f) => {
            if(f.type === "date" || f.type === "datetime") {
                dateFields.push(f.id);
            }
        });
        return dateFields;
    }

    const saveCSVAndCloseLoading = (res) => {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(
            new Blob([res], { type: 'text/csv' })
        );
        a.setAttribute("download", (dictConfig.conf.name ? dictConfig.conf.name + ".csv" : "data.csv"));
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        dispatch(setLoading(false));
    }

    const importStatus = (stat) => {
        if(stat) {
            if(stat == "success"){
                const abortCtrl = new AbortController();
                readTableRecordsPage(buildFetchFilter(searchVal),0,undefined, undefined, abortCtrl.signal, false).then((recordsPage)=>{
                    setRecordsReady(true);
                    setRecords([...recordsPage]);

                });
                setTimeout(()=>{
                    //sendMessageNewUserViewingTable();
                }, 1);
                dispatch(setLoading(false));
                dispatch(setSnackbar({
                    type: "success",
                    message: t("Records imported"),
                }));
                //send message on websocket about import data!!! and need to refresh rest open viewed table
            }
            if(stat == "error"){
                dispatch(setSnackbar({
                    type: "error",
                    message: t("Error") + ": " + t("Records not imported"),
                }));
            }
        }
    }

    return (
        <Box sx={{ width: '100%', padding: '5px'}}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between'}}>
                <Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Autocomplete
                                className={classes.selectDict}
                                disablePortal
                                id="combo-box-dicts-to-edit"
                                options={dictList}
                                sx={{ width: 300 }}
                                renderInput={(params) => <TextField {...params} label={t("Select dictionaries")} />}
                                value={dictConfig}
                                onChange={(event, selected) => setDictConfig(selected)}
                            />
                            <TextField
                                inputRef={searchRef}
                                id={_.uniqueId("search_")}
                                sx={{ m: 1, width: '25ch' }}
                                variant="outlined"
                                placeholder={t("Filter records")}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start"><SearchIcon/></InputAdornment>,
                                }}
                                onChange={(event) => setSearchVal(event.target.value)}
                                defaultValue={searchVal}
                                disabled={!recordsReady}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Box className={classes.additionalInfoBlock}>
                    <Box sx={{display: 'flex', flexDirection: 'row'}}>
                        {dictConfig?.conf?.additionalInfo?.icon &&
                        <Box><AgyleNamedIcon name={dictConfig?.conf?.additionalInfo?.icon}
                                             sx={Object.assign({fontSize: "20px"},(dictConfig?.conf?.additionalInfo?.iconColor ? {color: dictConfig?.conf?.additionalInfo?.iconColor}: {}))}/></Box>
                        }
                        {dictConfig?.conf?.additionalInfo?.title &&
                        <Box><Typography sx={{fontSize: "16px", fontWeight: "600"}}>{dictConfig?.conf?.additionalInfo?.title}</Typography></Box>
                        }
                    </Box>
                    {dictConfig?.conf?.additionalInfo?.text &&
                    <Typography>{dictConfig?.conf?.additionalInfo?.text}</Typography>
                    }

                </Box>
                <Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <ImportData disabled={dictConfig==null || !recordsReady} btnIconClass={classes.btnIcon} iconClass={classes.icon} confData={dictConfig?.conf} importStatus={importStatus}/>
                            <Button variant="outlined" className={classes.btnIcon} disabled={dictConfig==null || !recordsReady} onClick={exportCsv}><AgyleNamedIcon name="download" className={classes.icon}/></Button>
                            {/*{config?.consultantComponentEnabled && dictConfig?.conf?.additionalFunctions && dictConfig?.conf?.additionalFunctions.indexOf('manageMultiAvailableIn') > -1 &&*/}
                            {dictConfig?.conf?.additionalFunctions && dictConfig?.conf?.additionalFunctions.indexOf('manageMultiAvailableIn') > -1 &&
                            <Button variant="outlined" className={classes.btnIcon}
                                    disabled={dictConfig == null || !recordsReady} onClick={handleDialogManageAccess}>
                                <AgyleNamedIcon name="cogSettings" className={clsx(classes.btnWithIconIcon, "icon-manage")} title={t("Menage selectable visibility")}/>
                                {/*<span style={{paddingTop: "3px"}}>{t("Menage selectable visibility")}</span>*/}
                            </Button>
                            }
                            <Button variant="contained" className={classes.btnWithIcon} disabled={dictConfig==null || !recordsReady} onClick={handleAddNewDictElement}>
                                <AgyleNamedIcon name="plus" className={classes.btnWithIconIcon}/><span style={{paddingTop: "3px"}}>{t("Add new record")}</span>
                            </Button>

                        </Grid>
                    </Grid>
                </Box>
            </Box>
            {dictConfig != null &&
                <span>
                    <DictionariesAdminTable fields={dictConfig?.conf?.fields} loading={!recordsReady}
                                            dictName={dictConfig?.conf?.display} fieldsData={records} masterRecordId={masterRecordId}
                                            getMoreRecordsHandler={readTableRecordsPage} pageSize={defaultPageSize}
                                            rowAction={handleRowAction} idField={dictConfig?.conf?.idFieldName}
                                            saveEditedJSON={saveAddEditForm} additionalDicts={additionalDictsAll}
                                            webSocketChanel={"dictionary_admin_table_changes_"+dictConfig?.conf?.name}
                                            mergeEndpoint={dictConfig?.conf?.mergeEndpoint} additionalFunctions={dictConfig?.conf?.additionalFunctions}
                                            haveAllDataPages={allPagesRead} dividedMap={specialDividedFieldMap}
                                            filterHelper={filterFieldMap}
                                            activeModules={activeModules}/>
                    {!recordsReady &&
                    <LinearProgress />
                    }
                </span>
            }
            <Dialog open={addEdit.open} onClose={(e, r) => {handleCloseDialogEditForm(e);}}>
                <DictionariesAdminEditForm config={dictConfig?.conf} handleCancel={handleCloseDialogEditForm} save={saveAddEditForm}
                                           listeningChanel={wsMessageChanel} webSocketChanel={"dictionary_admin_table_changes_"+dictConfig?.conf?.name}
                                           record={addEdit.record} idField={dictConfig?.conf?.idFieldName} additionalDicts={additionalDicts}
                                           additionalDictsAll={additionalDictsAll} activeModules={activeModules}/>
            </Dialog>
            <Dialog open={mergeDialog.open} onClose={(e, r) => {handleCloseDialogEditForm(e);}}>
                <DictionariesAdminMergeForm config={dictConfig?.conf} handleCancel={handleCloseDialogMerge} merge={mergeRecords}
                                           listeningChanel={wsMessageChanel} webSocketChanel={"dictionary_admin_table_changes_"+dictConfig?.conf?.name}
                                           record={mergeDialog.record}/>
            </Dialog>
            <MessageBox
                title={t("CAUTION")}
                haveAccept={{ yes: t("Yes"), no: t("No") }}
                onAccept={handleDelete}
                onClose={() => setOpenConfirmDeleted(false)}
                message={t("Are you sure you want delete record?")}
                open={openConfirmDeleted}
            />
            <AgyleDialog
                title={"Dictionaries problem"}
                open={showDuplicatesMessage}
                onClose={() => {setShowDuplicatesMessage(false)}}
                width={"lg"}
                fullWidth={true}
                fullScreen={false}
                closeButtonOnHeader={true}
                disableSave={true}
            >
                <Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12} className={classes.headerInfo}>
                            <span className={classes.baseInfo}>{t("Duplicated codes and names")}</span>
                            <span className={classes.additionalInfo}>({t("above records will be not able to select")})</span>
                        </Grid>
                    </Grid>
                    {duplicatesInDict && duplicatesInDict.length > 0 &&
                        (<Grid container spacing={2} className={classes.header}>
                            <Grid item xs={3}>
                                {t("Dictionary")}
                            </Grid>
                            <Grid item xs={6}>
                                {t("Display")}

                            </Grid>
                            <Grid item xs={2}>
                                {t("CODE")}
                            </Grid>
                            <Grid item xs={1}>
                                {t("Repeat")}
                            </Grid>
                        </Grid>)}
                    {duplicatesInDict.map((duplicatedItem, index) => {
                        return (<Grid container spacing={2} className={index % 2 == 0 ? classes.evenRow : classes.oddRow}
                        key={"duplicate_items_" + duplicatedItem.dictName + "_name_" + duplicatedItem.name + "_code_" + duplicatedItem.code}  >
                        <Grid item xs={3} className={index % 2 == 0 ? classes.even : classes.odd}>
                            {duplicatedItem.dictName}
                        </Grid>
                        <Grid item xs={6} className={index % 2 == 0 ? classes.even : classes.odd}>
                            {duplicatedItem.name}

                        </Grid>
                        <Grid item xs={2} className={index % 2 == 0 ? classes.even : classes.odd}>
                            {duplicatedItem.code}
                        </Grid>
                        <Grid item xs={1} className={index % 2 == 0 ? classes.even : classes.odd}>
                            {duplicatedItem.records.length}
                        </Grid>
                        </Grid>)
                    })
                    }
                </Box>
            </AgyleDialog>
        </Box>
    )
}

